import { render, staticRenderFns } from "./wxsstock.vue?vue&type=template&id=40489851&"
import script from "./wxsstock.vue?vue&type=script&lang=js&"
export * from "./wxsstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports